module.exports = "\nspan.ac-groupby-item {\n    font-size: 10px;\n    color: #018dad\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/autocomplete/autocomplete.component.css
// module id = ./src/app/shared/autocomplete/autocomplete.component.css
// module chunks = main